<template>    
    <v-parallax
        height="900"
        :src="require(`@/assets/img/bg1.jpg`)"
    >
        <v-container>
            <v-row
                class="mt-10 mt-md-0"
                align="center"
            >
                <v-col
                    class="text-center"
                    cols="12"
                    md="5"
                    offset-md="1"
                >
                    <transition
                        appear
                        name="slide-fade"
                    >
                        <v-card
                            class="mx-auto"
                            outlined
                            dark
                            style="text-align: justify; padding: 25px 15px; background: rgba(0,0,0,0.6);"
                        >
                            <v-card-text class="my-3">
                                <h2 class="font-light">
                                    A través de este espacio podrás reportar cualquier caso de violencia de género y otras violencias.
                                </h2>
                                <br>
                                <h2 class="font-light">
                                    La Universidad de Guanajuato refrenda su compromiso con el fortalecimiento de una cultura de paz y no discriminación.
                                </h2>
                            </v-card-text>
                        </v-card>
                    </transition>
                </v-col>
                <v-col
                    class="text-center"
                    cols="12"
                    md="5"
                >
                    <transition
                        appear
                        name="slide-fade-right"
                    >
                        <v-card
                            class="violencia mx-12"
                            outlined
                            dark
                        >
                            <v-card-text class="my-2">
                                <h2
                                    class="font-light"
                                    style="color: #092F57 !important"
                                >
                                    REPORTE DE VIOLENCIA DE GÉNERO Y OTRAS VIOLENCIAS
                                </h2>
                                <br><br>
                                <v-btn
                                    rounded
                                    color="#FFD93E"
                                    x-large
                                    dark
                                    style="color:#1C5997"
                                    @click="$router.push('/ReporteViolencia'); "
                                >
                                    REPORTAR
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </transition>

                    <br>
                    <transition
                        appear
                        name="slide-fade-right"
                    >
                        <a
                            :href="`${publicPath == '/' ? publicPath : (publicPath + '/')}files/guia-basica-si-experimentas-violencia-genero-ug-ugto.pdf`"
                            target="_blank"
                            style="text-decoration:none;"
                        >
                            <v-card
                                class="card-guia"
                                outlined
                            >
                                <v-card-text class="my-2">
                                    <h3
                                        style="font-weight: normal!important; color: white;"
                                    >
                                        Si deseas consultar la guía básica 
                                        para la atención de casos de violencia de género da click aquí
                                    </h3>
                                </v-card-text>
                            </v-card>
                        </a>
                    </transition>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col
                    class="text-center"
                    cols="12"
                >
                    <transition
                        appear
                        name="slide-fade-down"
                    >
                        <p
                            class="mb-5"
                            style="margin-top: 20px; color: rgba(255, 255, 255, 1); font-size: 1.5rem; line-height: 1.5; font-weight: 300"
                        >
                            Ventanilla UGénero
                            <br>
                            <img
                                :src="require(`@/assets/img/ugenero.png`)"
                                alt=""
                                width="234"
                                height="97"
                            >
                        </p>
                    </transition>
                </v-col>
            </v-row>
        </v-container>
    </v-parallax>    
</template>
<script>

export default {
    name: "PaginaPrincipal",
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    }
}
</script>

<style scoped>
.font-light{
    font-weight: 300;
    color: white;
}

.slide-fade-enter-active {
  transition: all 3s ease;
}
.slide-fade-leave-active {
  transition: all 9s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-30px);
  opacity: 0;
}

.slide-fade-right-enter-active {
  transition: all 3s ease;
}
.slide-fade-right-leave-active {
  transition: all 9s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-right-enter, .slide-fade-right-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(30px);
  opacity: 0;
}

.slide-fade-down-enter-active {
  transition: all 3s ease;
}
.slide-fade-down-leave-active {
  transition: all 9s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-down-enter, .slide-fade-down-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}

.violencia {
  display: block;
  padding: 34px 20px 20px 20px;
  text-align: center;
  background: rgba(247,237,117,0.7);
  border: solid 1px #fff;
  border-radius: 7px;
  font-weight: bold;
  color: #092F57 !important;
  width: auto;
  height: auto;
  margin: 0 auto;
    margin-top: 0px;
  position: relative;
  font-family: 'Raleway', sans-serif;
  font-size: 15px !important;
  -webkit-box-shadow: 0px 0px 53px -6px rgba(0,0,0,0.36);
  -moz-box-shadow: 0px 0px 53px -6px rgba(0,0,0,0.36);
  box-shadow: 0px 0px 53px -6px rgba(0,0,0,0.36);
  margin-top: 0px;
}


.card-guia{
    background: rgba(62,89,104,0.9); 
    color: #fff !important;
    border: 2px solid transparent;
}

.card-guia:hover{
    background: none !important;
    color: #fff !important;
    background: none;
    border: 2px solid #fff;
}




</style>